(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-about-chapters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const DESKTOP = '(min-width: 990px)';
    const REDUCED = '(prefers-reduced-motion: reduce)';

    function clamp(v, lo, hi) {
      return Math.min(Math.max(v, lo), hi);
    }

    function setup(root) {
      const frame = root.querySelector('.cw-abt-ch__frame');
      const column = root.querySelector('[data-cw-chapters-column]');
      if (!frame || !column) return;

      const chapters = Array.from(root.querySelectorAll('[data-cw-chapter]'));
      const rails = Array.from(root.querySelectorAll('[data-cw-rail]'));
      const canTiles = Array.from(root.querySelectorAll('[data-cw-can-tile]'));
      const mqDesktop = window.matchMedia(DESKTOP);
      const mqReduced = window.matchMedia(REDUCED);
      let ticking = false;

      function pinned() {
        return mqDesktop.matches && !mqReduced.matches;
      }

      function reset() {
        root.classList.remove('is-pinned');
        root.style.height = '';
        column.style.transform = '';
        rails.forEach(function (r, i) {
          r.classList.toggle('is-active', i === 0);
        });
      }

      // How much page scroll the pinned section consumes, as a multiple of the
      // distance the column actually has to travel. 1 makes the column advance
      // one pixel per pixel scrolled, which is indistinguishable from not
      // pinning at all - the frame holds but its contents move at page speed.
      // Above 1 the content advances slower than the scroll, which is what
      // makes the section read as held.
      const speed = Math.max(parseFloat(root.dataset.scrollSpeed) || 1.8, 1);

      function contentTravel() {
        return Math.max(column.scrollHeight - frame.offsetHeight, 0);
      }

      function scrollLength() {
        return contentTravel() * speed;
      }

      function measure() {
        if (!pinned()) {
          reset();
          return;
        }
        root.classList.add('is-pinned');
        root.style.height = frame.offsetHeight + scrollLength() + 'px';
      }

      function update() {
        // The can rise is viewport geometry, so it runs pinned or not.
        canTiles.forEach(function (tile) {
          if (mqReduced.matches) {
            tile.style.setProperty('--cw-can-y', '0%');
            return;
          }
          const r = tile.getBoundingClientRect();
          const progress = clamp(
            (window.innerHeight - r.top) / (window.innerHeight * 0.75),
            0,
            1
          );
          tile.style.setProperty('--cw-can-y', (1 - progress) * 110 + '%');
        });

        if (!pinned()) return;

        const frameH = frame.offsetHeight;
        // Progress runs over the longer scroll length; the column only moves
        // by the distance it actually needs to. That ratio is the hold.
        const progress = clamp(
          -root.getBoundingClientRect().top / Math.max(scrollLength(), 1),
          0,
          1
        );
        const y = -progress * contentTravel();

        column.style.transform = 'translate3d(0,' + y + 'px,0)';

        // Active = last chapter whose top has passed 45% of the frame.
        const threshold = frameH * 0.45;
        let active = 0;
        chapters.forEach(function (c, i) {
          if (c.offsetTop + y <= threshold) active = i;
        });
        // On a very tall viewport the final chapter can be fully on screen
        // without its top ever clearing 45%, which would leave the rail
        // pointing at the previous chapter at the moment the block releases.
        if (progress >= 0.999) active = chapters.length - 1;
        rails.forEach(function (r, i) {
          r.classList.toggle('is-active', i === active);
        });
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      }

      function remeasure() {
        measure();
        update();
      }

      remeasure();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', remeasure);

      // The wrapper height is derived from the column's height, so it has to
      // be recomputed whenever that changes - late images, web fonts, or the
      // theme editor swapping a block. Measuring only at load left the pin
      // the wrong length and released it mid-chapter.
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          remeasure();
        }).observe(column);
      }
      mqDesktop.addEventListener('change', remeasure);
      mqReduced.addEventListener('change', remeasure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    }

    function init() {
      document.querySelectorAll('[data-cw-chapters]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-cw-chapters]').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-article-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-cw-sticky]');
    if (!bar) return;
    if (!('IntersectionObserver' in window)) return;

    const header = document.querySelector('.cw-ahd');
    const finalCta = document.querySelector('.cw-article-banner-section:last-of-type, .cw-ark__entry--ours:last-of-type');

    let pastHeader = false;
    let atEnd = false;
    function apply() { bar.hidden = !(pastHeader && !atEnd); }

    if (header) {
      new IntersectionObserver(function (entries) {
        pastHeader = !entries[0].isIntersecting;
        apply();
      }, { rootMargin: '0px' }).observe(header);
    } else {
      pastHeader = true;
    }

    if (finalCta) {
      new IntersectionObserver(function (entries) {
        atEnd = entries[0].isIntersecting;
        apply();
      }, { rootMargin: '0px' }).observe(finalCta);
    }

    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-article-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (event) {
      const btn = event.target.closest('[data-cw-video]');
      if (!btn) return;
      const id = btn.dataset.cwVideo;
      if (!id) return;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1';
      frame.title = btn.getAttribute('aria-label') || 'Video';
      frame.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      frame.className = 'cw-avd__iframe';
      btn.replaceWith(frame);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-contact-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      const chips = Array.from(root.querySelectorAll('[data-cw-topic]'));
      const input = root.querySelector('[data-cw-topic-input]');
      const comment = root.querySelector('[data-cw-comment]');
      if (!chips.length) return;

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (other) {
            const on = other === chip;
            other.classList.toggle('is-selected', on);
            other.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (input) input.value = chip.dataset.value || '';
          if (comment && chip.dataset.hint) comment.placeholder = chip.dataset.hint;
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-cw-contact]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-cw-contact]').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      const tabs = Array.from(root.querySelectorAll('[data-cw-faq-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-cw-faq-panel]'));
      const ghost = root.querySelector('[data-cw-faq-ghost]');
      if (!tabs.length) return;

      function openQuestion(card) {
        const panel = card.closest('[data-cw-faq-panel]');
        panel.querySelectorAll('[data-cw-faq-card]').forEach(function (other) {
          const on = other === card;
          other.classList.toggle('is-open', on);
          const btn = other.querySelector('[data-cw-faq-q]');
          const ans = other.querySelector('.cw-faqt__a');
          if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (ans) ans.hidden = !on;
        });
      }

      function activate(tab, focus) {
        const group = tab.dataset.group;
        tabs.forEach(function (t) {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });

        let active = null;
        panels.forEach(function (p) {
          const on = p.dataset.group === group;
          p.hidden = !on;
          if (on) active = p;
        });
        if (!active) return;

        // Tabs recolour the page: the active pill and the ghosted numeral
        // both take the group's accent.
        root.style.setProperty('--cw-faq-tabaccent', active.dataset.accent);
        if (ghost) ghost.style.color = active.dataset.accent;

        // First question of the newly shown group opens.
        const first = active.querySelector('[data-cw-faq-card]');
        if (first) openQuestion(first);

        if (focus) tab.focus();
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab, false);
          history.replaceState(null, '', '#' + tab.dataset.handle);
        });

        tab.addEventListener('keydown', function (event) {
          const i = tabs.indexOf(tab);
          let next = null;
          if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          activate(next, true);
        });
      });

      root.querySelectorAll('[data-cw-faq-q]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const card = btn.closest('[data-cw-faq-card]');
          if (card.classList.contains('is-open')) {
            card.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            const ans = card.querySelector('.cw-faqt__a');
            if (ans) ans.hidden = true;
            return;
          }
          openQuestion(card);
        });
      });

      // Deep link: #whats-in-it opens that group on load.
      const hash = window.location.hash.replace('#', '');
      const target = hash && tabs.find(function (t) { return t.dataset.handle === hash; });
      activate(target || tabs[0], false);
    }

    function init() {
      document.querySelectorAll('[data-cw-faq]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-cw-faq]').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-ingredients-breakdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      const tabs = Array.from(root.querySelectorAll('[data-cw-brk-tab]'));
      if (tabs.length < 2) return;

      function select(tab) {
        tabs.forEach(function (t) {
          const on = t === tab;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          // Toggling `hidden` only - the panel's content is already in the
          // document and must stay there for crawlers and for no-JS.
          if (panel) panel.hidden = !on;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (event) {
          let next = null;
          if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          select(next);
          next.focus();
        });
      });
    }

    function init() { document.querySelectorAll('.cw-brk').forEach(setup); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.cw-brk').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-ingredients-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      const tabs = Array.from(root.querySelectorAll('[data-cw-cmp-tab]'));
      if (tabs.length < 2) return;
      function select(tab) {
        tabs.forEach(function (t) {
          const on = t === tab;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (event) {
          let next = null;
          if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (!next) return;
          event.preventDefault();
          select(next);
          next.focus();
        });
      });
    }
    function init() { document.querySelectorAll('.cw-cmp').forEach(setup); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.cw-cmp').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      const hero = root.querySelector('.cw-pdp__hero');
      const thumbs = root.querySelectorAll('[data-cw-pdp-thumb]');
      if (!hero || !thumbs.length || hero.tagName !== 'IMG') return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          const full = thumb.dataset.full;
          if (!full) return;

          // The hero carries a srcset; clearing it stops the browser
          // resolving the old candidate over the new src.
          hero.removeAttribute('srcset');
          hero.src = full;
          hero.alt = thumb.dataset.alt || '';

          thumbs.forEach(function (other) {
            other.classList.toggle('is-active', other === thumb);
            other.setAttribute('aria-pressed', other === thumb ? 'true' : 'false');
          });
        });
      });
    }

    function init() {
      document.querySelectorAll('.cw-pdp__media').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('.cw-pdp__media').forEach(setup);
    });
  })();

  (function () {
    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'GBP',
      })
        .format(cents / 100)
        // Match Liquid's money_without_trailing_zeros, or the total would
        // switch from "£12" to "£12.00" the moment anything is clicked.
        .replace(/[.,]00$/, '');
    }

    function setup(root) {
      const packs = Array.from(root.querySelectorAll('[data-cw-pack]'));
      const qtyValue = root.querySelector('[data-cw-qty-value]');
      const qtyInput = root.querySelector('[data-cw-qty-input]');
      const variantInput = root.querySelector('[data-cw-variant-input]');
      const addLabel = root.querySelector('[data-cw-add-label]');
      const totalEl = root.querySelector('[data-cw-total]');
      const flavours = Array.from(root.querySelectorAll('[data-cw-flavour]'));

      let selected = packs.find(function (p) { return p.classList.contains('is-selected'); }) || packs[0];
      let qty = 1;
      let added = false;

      const params = new URLSearchParams(window.location.search);
      const wantedPack = params.get('pack');
      if (wantedPack) {
        const match = packs.find(function (p) {
          return p.querySelector('.cw-pdp__pack-title').textContent.trim() === wantedPack;
        });
        if (match) selected = match;
      }
      const wantedQty = parseInt(params.get('qty'), 10);
      if (wantedQty >= 1 && wantedQty <= 9) qty = wantedQty;

      function render() {
        if (!selected) return;
        const cans = parseInt(selected.dataset.cans, 10) || 1;
        const unit = parseInt(selected.dataset.price, 10) || 0;

        packs.forEach(function (p) {
          const on = p === selected;
          p.classList.toggle('is-selected', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        if (variantInput) variantInput.value = selected.dataset.variantId;
        // Sold-out products still show the pack selector, so the back-in-stock
        // trigger must track the chosen pack rather than stay on the first.
        const notify = root.querySelector('[data-cw-notify]');
        if (notify) notify.dataset.variantId = selected.dataset.variantId;
        if (qtyInput) qtyInput.value = qty;
        if (qtyValue) qtyValue.textContent = qty;

        // One-time price only. Subscription pricing comes from Shopify's
        // selling plan allocation and is rendered by the Subscriptions app
        // block, not by this script.
        const total = unit * qty;
        if (totalEl) totalEl.textContent = money(total);

        if (addLabel && !added) {
          addLabel.textContent = addLabel.dataset.base.replace('{n}', cans * qty);
        }

        // Carry the current pack and quantity across a flavour switch.
        flavours.forEach(function (a) {
          const base = a.dataset.baseUrl;
          const title = selected.querySelector('.cw-pdp__pack-title').textContent.trim();
          a.href = base + '?pack=' + encodeURIComponent(title) + '&qty=' + qty;
        });
      }

      function clearAdded() {
        if (!added) return;
        added = false;
        if (addLabel) addLabel.classList.remove('is-added');
        render();
      }

      packs.forEach(function (p) {
        p.addEventListener('click', function () {
          selected = p;
          clearAdded();
          render();
        });
      });

      root.querySelectorAll('[data-cw-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const next = qty + parseInt(btn.dataset.cwQty, 10);
          if (next < 1 || next > 9) return;
          qty = next;
          clearAdded();
          render();
        });
      });

      if (addLabel) addLabel.dataset.base = addLabel.textContent.replace(/\d+/, '{n}');

      // Dawn's own event bus, rather than a second cart implementation.
      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (!event || event.source !== 'product-form') return;
          added = true;
          if (addLabel) {
            addLabel.textContent = addLabel.dataset.addedText || 'Added ✓';
            addLabel.classList.add('is-added');
          }
        });
      }

      render();
    }

    function init() {
      document.querySelectorAll('[data-cw-buybox]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-cw-buybox]').forEach(setup);
    });
  })();

  (function () {
    // Klaviyo only registers its openBackInStockModal handler once Back in
    // Stock is enabled for the store; before that it swallows the call and
    // logs "Unable to process event". So the CTA drives our own dialog and
    // posts to Klaviyo's public client endpoint instead, which works with
    // nothing but the onsite script already on the page. Guarded so a page
    // carrying both the buy box and the shop cards binds only once.
    if (window.__cwBisBound) return;
    window.__cwBisBound = true;

    const REVISION = '2024-10-15';
    let modal = null;
    let variantId = null;
    let lastFocus = null;

    function part(name) {
      return modal ? modal.querySelector('[data-cw-bis-' + name + ']') : null;
    }

    function companyId() {
      if (modal && modal.dataset.companyId) return modal.dataset.companyId;
      let found = null;
      document.querySelectorAll('script[src]').forEach(function (script) {
        if (found || script.src.indexOf('klaviyo.js') === -1) return;
        const match = script.src.match(/company_id=([A-Za-z0-9]+)/);
        if (match) found = match[1];
      });
      return found;
    }

    function setMessage(text, isError) {
      const msg = part('msg');
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('cw-bis__msg--error', !!isError);
    }

    function close() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.documentElement.classList.remove('cw-bis-open');
      if (lastFocus) lastFocus.focus();
    }

    function open(trigger) {
      modal = document.querySelector('[data-cw-bis-modal]');
      if (!modal) return false;

      variantId = trigger.dataset.variantId;
      if (!variantId) return false;
      lastFocus = trigger;

      // Name what is being waited for: a shop card carries six pack buttons,
      // so an anonymous dialog would not say which one it signed you up for.
      const name = part('product');
      if (name) {
        name.textContent = trigger.dataset.notifyName || '';
        name.hidden = !name.textContent;
      }

      const form = part('form');
      if (form) form.hidden = false;
      setMessage('');

      const input = part('email');
      if (input) input.value = '';

      const submit = part('submit');
      if (submit) submit.disabled = false;

      modal.hidden = false;
      document.documentElement.classList.add('cw-bis-open');
      if (input) input.focus();
      return true;
    }

    function subscribe(email) {
      const company = companyId();
      if (!company || !variantId) return Promise.reject(new Error('not configured'));

      return fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: REVISION },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
                }
              }
            }
          })
        }
      ).then(function (response) {
        if (!response.ok) throw new Error('Klaviyo returned ' + response.status);
        return true;
      });
    }

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-cw-notify], [data-cw-shop-notify]');
      if (trigger) {
        if (open(trigger)) event.preventDefault();
        return;
      }
      if (event.target.closest('[data-cw-bis-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    document.addEventListener('submit', function (event) {
      const form = event.target.closest('[data-cw-bis-form]');
      if (!form) return;
      event.preventDefault();

      const input = part('email');
      const submit = part('submit');
      const email = input ? input.value.trim() : '';

      if (email.indexOf('@') < 1 || email.indexOf('.') === -1) {
        setMessage(form.dataset.invalid, true);
        if (input) input.focus();
        return;
      }

      if (submit) submit.disabled = true;
      setMessage(form.dataset.sending);

      subscribe(email)
        .then(function () {
          form.hidden = true;
          setMessage(form.dataset.success);
        })
        .catch(function () {
          setMessage(form.dataset.error, true);
          if (submit) submit.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-shop-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'GBP',
      })
        .format(cents / 100)
        .replace(/[.,]00$/, '');
    }

    function setup(card) {
      const packs = Array.from(card.querySelectorAll('[data-cw-shop-pack]'));
      const input = card.querySelector('[data-cw-shop-variant]');
      const label = card.querySelector('[data-cw-shop-addlabel]');
      const total = card.querySelector('[data-cw-shop-total]');
      if (!packs.length) return;

      const base = label ? label.textContent.trim().replace(/\d+/, '{n}') : '';

      packs.forEach(function (pack) {
        pack.addEventListener('click', function () {
          packs.forEach(function (other) {
            const on = other === pack;
            other.classList.toggle('is-selected', on);
            other.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (input) input.value = pack.dataset.variantId;
          if (label) label.textContent = base.replace('{n}', pack.dataset.cans);
          if (total) total.textContent = money(parseInt(pack.dataset.price, 10) || 0);
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-cw-shopcard]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-cw-shopcard]').forEach(setup);
    });
  })();

  (function () {
    // Klaviyo only registers its openBackInStockModal handler once Back in
    // Stock is enabled for the store; before that it swallows the call and
    // logs "Unable to process event". So the CTA drives our own dialog and
    // posts to Klaviyo's public client endpoint instead, which works with
    // nothing but the onsite script already on the page. Guarded so a page
    // carrying both the buy box and the shop cards binds only once.
    if (window.__cwBisBound) return;
    window.__cwBisBound = true;

    const REVISION = '2024-10-15';
    let modal = null;
    let variantId = null;
    let lastFocus = null;

    function part(name) {
      return modal ? modal.querySelector('[data-cw-bis-' + name + ']') : null;
    }

    function companyId() {
      if (modal && modal.dataset.companyId) return modal.dataset.companyId;
      let found = null;
      document.querySelectorAll('script[src]').forEach(function (script) {
        if (found || script.src.indexOf('klaviyo.js') === -1) return;
        const match = script.src.match(/company_id=([A-Za-z0-9]+)/);
        if (match) found = match[1];
      });
      return found;
    }

    function setMessage(text, isError) {
      const msg = part('msg');
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('cw-bis__msg--error', !!isError);
    }

    function close() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.documentElement.classList.remove('cw-bis-open');
      if (lastFocus) lastFocus.focus();
    }

    function open(trigger) {
      modal = document.querySelector('[data-cw-bis-modal]');
      if (!modal) return false;

      variantId = trigger.dataset.variantId;
      if (!variantId) return false;
      lastFocus = trigger;

      // Name what is being waited for: a shop card carries six pack buttons,
      // so an anonymous dialog would not say which one it signed you up for.
      const name = part('product');
      if (name) {
        name.textContent = trigger.dataset.notifyName || '';
        name.hidden = !name.textContent;
      }

      const form = part('form');
      if (form) form.hidden = false;
      setMessage('');

      const input = part('email');
      if (input) input.value = '';

      const submit = part('submit');
      if (submit) submit.disabled = false;

      modal.hidden = false;
      document.documentElement.classList.add('cw-bis-open');
      if (input) input.focus();
      return true;
    }

    function subscribe(email) {
      const company = companyId();
      if (!company || !variantId) return Promise.reject(new Error('not configured'));

      return fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: REVISION },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
                }
              }
            }
          })
        }
      ).then(function (response) {
        if (!response.ok) throw new Error('Klaviyo returned ' + response.status);
        return true;
      });
    }

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-cw-notify], [data-cw-shop-notify]');
      if (trigger) {
        if (open(trigger)) event.preventDefault();
        return;
      }
      if (event.target.closest('[data-cw-bis-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    document.addEventListener('submit', function (event) {
      const form = event.target.closest('[data-cw-bis-form]');
      if (!form) return;
      event.preventDefault();

      const input = part('email');
      const submit = part('submit');
      const email = input ? input.value.trim() : '';

      if (email.indexOf('@') < 1 || email.indexOf('.') === -1) {
        setMessage(form.dataset.invalid, true);
        if (input) input.focus();
        return;
      }

      if (submit) submit.disabled = true;
      setMessage(form.dataset.sending);

      subscribe(email)
        .then(function () {
          form.hidden = true;
          setMessage(form.dataset.success);
        })
        .catch(function () {
          setMessage(form.dataset.error, true);
          if (submit) submit.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(root) {
      const video = root.querySelector('.cw-vhero__video');
      if (!video || video.tagName !== 'VIDEO') return;

      const toggle = root.querySelector('[data-cw-vhero-toggle]');
      const toggleText = root.querySelector('[data-cw-vhero-toggle-text]');
      const mute = root.querySelector('[data-cw-vhero-mute]');
      const muteText = root.querySelector('[data-cw-vhero-mute-text]');

      // Paused by default under reduced motion, so the poster is what shows.
      let wantsPlayback = !reduceMotion.matches;
      let inView = true;

      function paint() {
        if (!toggle || !toggleText) return;
        const playing = !video.paused;
        toggleText.textContent = playing
          ? toggle.dataset.labelPause
          : toggle.dataset.labelPlay;
        toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
        root.classList.toggle('cw-vhero--paused', !playing);
      }

      function sync() {
        if (wantsPlayback && inView) {
          const p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
        paint();
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          wantsPlayback = video.paused;
          sync();
        });
      }

      if (mute && muteText) {
        mute.addEventListener('click', function () {
          video.muted = !video.muted;
          muteText.textContent = video.muted
            ? mute.dataset.labelUnmute
            : mute.dataset.labelMute;
          mute.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        });
      }

      video.addEventListener('play', paint);
      video.addEventListener('pause', paint);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              inView = entry.isIntersecting;
              sync();
            });
          },
          { threshold: 0.1 }
        ).observe(root);
      }

      reduceMotion.addEventListener('change', function (event) {
        wantsPlayback = !event.matches;
        sync();
      });

      sync();
    }

    function init() {
      document.querySelectorAll('.cw-vhero').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme editor re-renders sections without a full page load.
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('.cw-vhero').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
